import axios from 'axios';


export default class PurchaseVisibility {

  constructor(el) {

    this.toggleAction = window.routes.togglePurchaseVisibility[0];
    this.toggleMethod = window.routes.togglePurchaseVisibility[1];
    this.toggleElement = el;
    this.movieContainer = el.parentNode.parentNode.parentNode;
    this.itemId = el.dataset.itemid;
    this.registerEvents();
  }

  registerEvents () {

    this.toggleElement.addEventListener('click', this.handleToggle.bind(this));
  }

  handleToggle (e) {

    if (e.preventDefault) {

      e.preventDefault();
    }

    axios({

      method: this.toggleMethod,
      url: this.toggleAction,
      data: { id: this.itemId },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(res => {

      if (res.data.hidden) {

        this.movieContainer.parentNode.removeChild(this.movieContainer);
      } else {

        this.movieContainer.classList.remove('has-purchase-hidden');
        e.target.classList.remove('i-show-purchase');
        e.target.classList.add('i-hide-purchase');
      }
    })
    .catch(error => {
      window.console.log(error);

      throw `PurchaseVisibility.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
    });
  }
}
